import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectbackground } from '../redux/Slices/toggleBackgroundSlice';
import { PiPencilSimpleLineThin } from "react-icons/pi";
import { AiTwotoneDelete } from "react-icons/ai";
import Thread from '../components/Dashboard/DashCRUD/Thread';
import PolicyCardContent from '../components/Dashboard/DashCRUD/policyCardContent';
import { policyByID, userInfo } from '../redux/Selectors/selectors';
import ChatPopUp from '../components/ChatBox/ChatPopUp';
import { delete_policy_card_API, get_policy_card_by_id } from '../redux/Thunks/policyCardThunk';
import Alert from '../components/common/Alert';
import Loading from '../components/common/loading';
import Footer from '../layout/Footer';
import { selectRenderedState } from '../redux/Slices/sharedUseEffectSlice';



const PolicyCardByID = () => {
    let userID;
    const user = useSelector(state => userInfo(state))
    if (user) {
        userID = user.id;
    }

    const { policyCardID } = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch()

    // const [policyPrompt, setPolicyPrompt] = useState("")
    const [popUp, setPopUp] = useState(false)  //PopUp Hidden initially
    const [loading, setLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const filteredCard = useSelector((state) => policyByID(state, policyCardID))
    const [cardByID, setCardByID] = useState(filteredCard)

    const toRefresh = useSelector(state => selectRenderedState(state))
    const currentMode = useSelector(state => selectbackground(state)) //Background color mode


    const svgTotal = [1, 2, 3];


    const handleDelete = () => {
        setLoading(true)
        try {
            dispatch(
                delete_policy_card_API({
                    eid: cardByID?.eid
                })
            )
            setPopUp(!popUp)
            navigate(`/dashboard`)
        } catch (error) {
            if (error) {
                setLoading(false)
                setShowError(true)
            }
        }

    }

    async function fetchData(){
        setLoading(true)
        const data= await dispatch(get_policy_card_by_id({eid : policyCardID})).unwrap()
        setCardByID(data)
        setLoading(false)
    }


    useEffect(() => {
        if(!cardByID?.category){
           fetchData()
        }
        // eslint-disable-next-line 
    }, [user, toRefresh])


    let editAndDeleteButtons;
    if (cardByID && user) {
        if (parseFloat(cardByID.policy_author_id) === parseFloat(userID)) {
            editAndDeleteButtons = (<div className='hidden absolute top-2 right-5 space-x-4'>
                <PiPencilSimpleLineThin
                    className="cursor-pointer text-xl sm:text-4xl inline z-10"
                    onClick={() => {
                        navigate(`/dashboard/edit/${policyCardID}`)
                    }}
                />

                <AiTwotoneDelete
                    className="cursor-pointer text-xl sm:text-4xl inline z-10"
                    onClick={() => {
                        setPopUp(!popUp)
                    }}
                />
            </div>)
        }

    }




    return (
        <div className=' bg-nightModeDark text-white '>

            {/* POLICY CARD STARTS*/}
            <div className='flex'>
                <div className='hidden sm:block w-[12%] lg:w-[8%] mr-2.5'>

                    <aside className='sm:px-3 py-4 my-4 lg:my-14 bg-customBlue space-y-3'>

                        {svgTotal.map((element, index) => {
                        return (<div key={index} className='h-[80px]'>
                            {/* <svg className='hidden md:block' height="100" width="70">
                            <circle cx="35" cy="40" r="35" fill="#3C6E71" />
                        </svg> */}

                        {/* PHONE VIEW */}
                        {/* <svg className='md:hidden block' height="45" width="50">
                            <circle cx={40/2} cy={60/3} r="15" fill="#3C6E71" />
                        </svg> */}
                        </div>
                        )}
                        )}
                    </aside>
                </div>


                <section className='w-full sm:w-[90%] p-4 my-4 sm:m-4 relative '>
                    {loading ?
                    <div className='flex flex-col justify-center items-center w-full h-[30vh]'>
                    <div className=' w-10 lg:w-[80px] h-10 lg:h-[80px] animate-spin rounded-full
                    border-t-4 border-greenOnDarkMode' />
                    <p className='text-white mt-2 font-semibold'>Fetching Card</p>
                    </div>
                    :
                    <div className=''>
                    {cardByID && <PolicyCardContent
                        currentMode={currentMode}
                        category={cardByID.category}
                        content={cardByID.content}
                        policy_makers={cardByID.policy_makers}
                        regional_info={cardByID.regional_info}
                        effective_date={cardByID.effective_date}
                        showAll={true}
                    />}

                    {editAndDeleteButtons}
                    </div>
                    }
                </section>
            </div>
            {/* POLICY CARD END */}

            <Thread />

            <Footer />




            {/* POP UP */}
            {popUp && <ChatPopUp
                objectModel="User Card?"
                handleClosePopUp={() => setPopUp(!popUp)}
                handleCancel={() => setPopUp(!popUp)}
                promptTarget="This user card"
                handleDelete={handleDelete}

            />}

            {loading &&  <Loading width="w-full"/>}
            {showError && <Alert
                isVisible={showError}
                message="Oops! Something went wrong."
                type="error"
            />}
        </div>

    )
}

export default PolicyCardByID
